export default __webpack_public_path__ + "static/media/backward.cc70dd7a.svg";